import type { RouteObject } from 'react-router-dom';
import { Login, Register } from '../../modules/auth';




export const PublicRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
]; 